<template>
  <v-row align="center" justify="center" no-gutters style="height: 100%">
    <v-card class="item" elevation="24">
      <v-card-title class="ma-2 justify-center text-h3 font-weight-bold">
        {{ siteName }}
      </v-card-title>
      <v-card-text class="py-2 pa-sm-4">
        <!-- <v-form ref="form" lazy-validation> -->
        <!-- <v-text-field
            label="帳號"
            prepend-icon="mdi-account"
            v-model="account"
            autofocus
          /> -->
        <!-- 26620105 -->
        <v-text-field
          label="請輸入認證碼"
          prepend-icon="mdi-lock"
          :type="showCode ? 'text' : 'password'"
          :append-icon="showCode ? 'mdi-eye' : 'mdi-eye-off'"
          v-model="code"
          @click:append="showCode = !showCode"
          @keyup.enter="login"
          autofocus
          inputmode="numeric"
        />
        <!-- </v-form> -->
      </v-card-text>
      <v-card-actions class="pa-4">
        <v-row justify="center" align="center">
          <v-col cols="12">
            <v-btn color="primary" @click="login" block class="font-weight-bold"> 登入 </v-btn>
          </v-col>
          <!-- <v-col class="text-center pa-2" cols="12">
            <v-btn text color="light-blue">忘記密碼?</v-btn>
          </v-col> -->
        </v-row>
      </v-card-actions>
    </v-card>
  </v-row>
</template>

<script>
import axios from 'axios'
import qs from 'qs'
import { bus } from '@/bus.js'
export default {
  inject: ['siteName'],
  data() {
    return {
      code: '',
      showCode: false,
    }
  },
  methods: {
    async login() {
      const payload = qs.stringify({ code: this.code })
      try {
        await axios.get('/api/attendance/worker_login', {
          withCredentials: true,
        })
        const res = await axios.post('/api/attendance/worker_login', payload, {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
        })

        if (res.data.status === 'success') {
          const screenWidth = window.innerWidth
          const staff = {
            id: res.data.data.employee_id,
            job: res.data.data.employee_job,
            name: res.data.data.employee_name,
          }
          localStorage.setItem('staff', JSON.stringify(staff))
          localStorage.setItem('isStaffLogin', true)
          bus.$emit('staff-logged-in', staff)
          this.$router.replace(screenWidth < 768 ? '/m/home' : '/')
        } else {
          alert(res.data.data)
        }
      } catch (err) {
        console.error(err)
      }
    },
  },
}
</script>
<style scoped>
.item {
  align-content: center;
  height: 50vh;
  margin: 16px;
  padding: 32px;
}
</style>
